import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { taskGroupBackend } from './task-group.backend';
import { taskGroupReducer } from './task-group.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('taskGroup', taskGroupReducer),
    BackendModule.forFeature('taskGroup', taskGroupBackend),
  ],
})
export class DatastoreTaskGroupModule {}
